import * as Scrivito from "scrivito";
import I18n from "^/config/i18n";

function NavigationLink({ to, direction }) {
  if (!to) {
    return null;
  }
  return (
    <Scrivito.LinkTag
      to={to}
      className={`btn btn-block font-weight-light btn-link px-0 text-blue text-${direction}`}
    >
      <i className={`las la-angle-${direction} f float-${direction}`} />
      <span
        className={`m${direction === "right" ? "r" : "l"}-3 p${
          direction === "right" ? "r" : "l"
        }-3 d-block`}
      >
        {direction === "right"
          ? I18n.t("BlogPost next article")
          : I18n.t("BlogPost previous article")}
        :
        <br />
        {to.get("title")}
      </span>
    </Scrivito.LinkTag>
  );
}
export default Scrivito.connect(NavigationLink);
